/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_CreatedInputs */

const id_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat:`)
};

const ms_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicipta:`)
};

const da_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettet:`)
};

const de_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt:`)
};

const en_us2_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created:`)
};

const es_es2_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creada:`)
};

const es_mx2_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creada:`)
};

const fil_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginawa:`)
};

const fr_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé le :`)
};

const it_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creata:`)
};

const hu_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozva:`)
};

const nl_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangemaakt:`)
};

const no_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettet:`)
};

const pl_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utworzona:`)
};

const pt_br2_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado:`)
};

const pt_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criada:`)
};

const ro_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creat:`)
};

const fi_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luotu:`)
};

const sv_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapad:`)
};

const vi_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo:`)
};

const tr_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma:`)
};

const cs_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno:`)
};

const bg_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Създадено:`)
};

const ru_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создана:`)
};

const uk_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створено:`)
};

const ar_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء:`)
};

const hi_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्मित:`)
};

const th_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างเมื่อ:`)
};

const ja_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日：`)
};

const zh_cn2_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于：`)
};

const zh_hant1_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立於：`)
};

const ko_notifications_created = /** @type {(inputs: Notifications_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성일:`)
};

/**
* | output |
* | --- |
* | "Created:" |
*
* @param {Notifications_CreatedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_created = /** @type {((inputs?: Notifications_CreatedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_CreatedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_created(inputs)
	if (locale === "ms") return ms_notifications_created(inputs)
	if (locale === "da") return da_notifications_created(inputs)
	if (locale === "de") return de_notifications_created(inputs)
	if (locale === "en-US") return en_us2_notifications_created(inputs)
	if (locale === "es-ES") return es_es2_notifications_created(inputs)
	if (locale === "es-MX") return es_mx2_notifications_created(inputs)
	if (locale === "fil") return fil_notifications_created(inputs)
	if (locale === "fr") return fr_notifications_created(inputs)
	if (locale === "it") return it_notifications_created(inputs)
	if (locale === "hu") return hu_notifications_created(inputs)
	if (locale === "nl") return nl_notifications_created(inputs)
	if (locale === "no") return no_notifications_created(inputs)
	if (locale === "pl") return pl_notifications_created(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_created(inputs)
	if (locale === "pt") return pt_notifications_created(inputs)
	if (locale === "ro") return ro_notifications_created(inputs)
	if (locale === "fi") return fi_notifications_created(inputs)
	if (locale === "sv") return sv_notifications_created(inputs)
	if (locale === "vi") return vi_notifications_created(inputs)
	if (locale === "tr") return tr_notifications_created(inputs)
	if (locale === "cs") return cs_notifications_created(inputs)
	if (locale === "bg") return bg_notifications_created(inputs)
	if (locale === "ru") return ru_notifications_created(inputs)
	if (locale === "uk") return uk_notifications_created(inputs)
	if (locale === "ar") return ar_notifications_created(inputs)
	if (locale === "hi") return hi_notifications_created(inputs)
	if (locale === "th") return th_notifications_created(inputs)
	if (locale === "ja") return ja_notifications_created(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_created(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_created(inputs)
	return ko_notifications_created(inputs)
});
export { notifications_created as "notifications.created" }